import { render, staticRenderFns } from "./DialogEditStaff.vue?vue&type=template&id=07d4a658&"
import script from "./DialogEditStaff.vue?vue&type=script&lang=js&"
export * from "./DialogEditStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports